<div class="bp-thumbnail-wrapper">
  <div *ngIf="!showAxis" class="bp-thumbnail-outline"></div>

  <ng-container *ngIf="showAxis">
    <div class="axis tl" *ngIf="active === 'tl'">
      <div class="ax x"></div>
      <div class="ax y"></div>
      <div class="x caption">x</div>
      <div class="y caption">y</div>
    </div>
    <div class="axis tr" *ngIf="active === 'tr'">
      <div class="ax x"></div>
      <div class="ax y"></div>
      <div class="x caption">x</div>
      <div class="y caption">y</div>
    </div>
    <div class="axis br" *ngIf="active === 'br'">
      <div class="ax x"></div>
      <div class="ax y"></div>
      <div class="x caption">x</div>
      <div class="y caption">y</div>
    </div>
    <div class="axis bl" *ngIf="active === 'bl'">
      <div class="ax x"></div>
      <div class="ax y"></div>
      <div class="x caption">x</div>
      <div class="y caption">y</div>
    </div>
  </ng-container>

  <div class="marker tl" *ngIf="active === 'tl'"></div>
  <div class="marker tr" *ngIf="active === 'tr'"></div>
  <div class="marker br" *ngIf="active === 'br'"></div>
  <div class="marker bl" *ngIf="active === 'bl'"></div>
  <div class="marker c" *ngIf="active === 'c'"></div>
</div>
